/* eslint-disable */
export default {
  cancel: 'Cancelar',
  pmiChangeConfirmed: 'Alterar',
  pmiChangeConfirmTitle: 'Alterar configurações da reunião pessoal?',
  pmiChangeConfirmContext:
    'Modificar essas configurações afetará todas as reuniões que usam sua ID ou nome de reunião pessoal, incluindo as que você já agendou',
  updatePassword: 'Atualizar senha',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
